var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLoadinginline = function SvgLoadinginline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 3.143A7.862 7.862 0 0 0 3.143 11 7.862 7.862 0 0 0 11 18.857 7.862 7.862 0 0 0 18.857 11 7.862 7.862 0 0 0 11 3.143ZM0 11C0 4.928 4.928 0 11 0s11 4.928 11 11-4.928 11-11 11S0 17.072 0 11Z",
    fill: "#fff",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.378 12.855a1.572 1.572 0 0 1 .917 2.025c-1.717 4.557-6.337 7.58-11.411 7.063a1.571 1.571 0 1 1 .319-3.127c3.619.37 6.924-1.787 8.15-5.044a1.572 1.572 0 0 1 2.025-.917Z",
    fill: "#fff"
  })));
};
export default SvgLoadinginline;